/**
 * 用于配置全局的参数
 */
var options = {
  jsApiToken: '',
  timeout: 5000,
  debug: false,
  startProcess: function startProcess(processName, id) {
    if (!options.debug) return;
    console.log("[rpc] [" + processName + "] id [" + id + "]\u5F00\u59CB");
  },
  onQueueShift: function onQueueShift(processName, id, diff) {
    if (!options.debug) return;
    console.log("[rpc] [" + processName + "] id [" + id + "] \u4ECE\u961F\u5217\u4E2D\u79FB\u9664\uFF0C\u5F00\u59CB\u53D1\u8D77rpc\u3002\u961F\u5217\u7B49\u5F85\u8017\u65F6\uFF1A" + diff + "ms");
  },
  endProcess: function endProcess(processName, id, diff, err) {
    if (!options.debug) return;
    console.log("[rpc] [" + processName + "] id [" + id + "] \u8C03\u7528" + (err ? '失败' : '成功') + " \u8017\u65F6: " + diff + "ms ", err);
  }
};
/**
 * 对于native-api进行配置
 * @param opts
 */
function config(opts) {
  if (typeof opts.timeout === 'number') {
    options.timeout = opts.timeout;
  }
  if (typeof opts.debug === 'boolean') {
    options.debug = opts.debug;
  }
  if (typeof opts.startProcess === 'function') {
    options.startProcess = opts.startProcess;
  }
  if (typeof opts.onQueueShift === 'function') {
    options.onQueueShift = opts.onQueueShift;
  }
  if (typeof opts.endProcess === 'function') {
    options.endProcess = opts.endProcess;
  }
  if (opts.jsApiToken) {
    options.jsApiToken = opts.jsApiToken;
  }
}

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return r;
  };
  var t,
    r = {},
    e = Object.prototype,
    n = e.hasOwnProperty,
    o = "function" == typeof Symbol ? Symbol : {},
    i = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    u = o.toStringTag || "@@toStringTag";
  function c(t, r, e, n) {
    Object.defineProperty(t, r, {
      value: e,
      enumerable: !n,
      configurable: !n,
      writable: !n
    });
  }
  try {
    c({}, "");
  } catch (t) {
    c = function (t, r, e) {
      return t[r] = e;
    };
  }
  function h(r, e, n, o) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype);
    return c(a, "_invoke", function (r, e, n) {
      var o = 1;
      return function (i, a) {
        if (3 === o) throw Error("Generator is already running");
        if (4 === o) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var u = n.delegate;
          if (u) {
            var c = d(u, n);
            if (c) {
              if (c === f) continue;
              return c;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (1 === o) throw o = 4, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = 3;
          var h = s(r, e, n);
          if ("normal" === h.type) {
            if (o = n.done ? 4 : 2, h.arg === f) continue;
            return {
              value: h.arg,
              done: n.done
            };
          }
          "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
        }
      };
    }(r, n, new Context(o || [])), !0), a;
  }
  function s(t, r, e) {
    try {
      return {
        type: "normal",
        arg: t.call(r, e)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  r.wrap = h;
  var f = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var l = {};
  c(l, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    y = p && p(p(x([])));
  y && y !== e && n.call(y, i) && (l = y);
  var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
  function g(t) {
    ["next", "throw", "return"].forEach(function (r) {
      c(t, r, function (t) {
        return this._invoke(r, t);
      });
    });
  }
  function AsyncIterator(t, r) {
    function e(o, i, a, u) {
      var c = s(t[o], t, i);
      if ("throw" !== c.type) {
        var h = c.arg,
          f = h.value;
        return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
          e("next", t, a, u);
        }, function (t) {
          e("throw", t, a, u);
        }) : r.resolve(f).then(function (t) {
          h.value = t, a(h);
        }, function (t) {
          return e("throw", t, a, u);
        });
      }
      u(c.arg);
    }
    var o;
    c(this, "_invoke", function (t, n) {
      function i() {
        return new r(function (r, o) {
          e(t, n, r, o);
        });
      }
      return o = o ? o.then(i, i) : i();
    }, !0);
  }
  function d(r, e) {
    var n = e.method,
      o = r.i[n];
    if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
    var i = s(o, r.i, e.arg);
    if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
    var a = i.arg;
    return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function w(t) {
    this.tryEntries.push(t);
  }
  function m(r) {
    var e = r[4] || {};
    e.type = "normal", e.arg = t, r[4] = e;
  }
  function Context(t) {
    this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
  }
  function x(r) {
    if (null != r) {
      var e = r[i];
      if (e) return e.call(r);
      if ("function" == typeof r.next) return r;
      if (!isNaN(r.length)) {
        var o = -1,
          a = function e() {
            for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
            return e.value = t, e.done = !0, e;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof r + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), c(GeneratorFunctionPrototype, u, GeneratorFunction.displayName = "GeneratorFunction"), r.isGeneratorFunction = function (t) {
    var r = "function" == typeof t && t.constructor;
    return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
  }, r.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
  }, r.awrap = function (t) {
    return {
      __await: t
    };
  }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
    return this;
  }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(h(t, e, n, o), i);
    return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, g(v), c(v, u, "Generator"), c(v, i, function () {
    return this;
  }), c(v, "toString", function () {
    return "[object Generator]";
  }), r.keys = function (t) {
    var r = Object(t),
      e = [];
    for (var n in r) e.unshift(n);
    return function t() {
      for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
      return t.done = !0, t;
    };
  }, r.values = x, Context.prototype = {
    constructor: Context,
    reset: function (r) {
      if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0][4];
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (r) {
      if (this.done) throw r;
      var e = this;
      function n(t) {
        a.type = "throw", a.arg = r, e.next = t;
      }
      for (var o = e.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i[4],
          u = this.prev,
          c = i[1],
          h = i[2];
        if (-1 === i[0]) return n("end"), !1;
        if (!c && !h) throw Error("try statement without catch or finally");
        if (null != i[0] && i[0] <= u) {
          if (u < c) return this.method = "next", this.arg = t, n(c), !0;
          if (u < h) return n(h), !1;
        }
      }
    },
    abrupt: function (t, r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
          var o = n;
          break;
        }
      }
      o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
      var i = o ? o[4] : {};
      return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
    },
    complete: function (t, r) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
    },
    finish: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
      }
    },
    catch: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[0] === t) {
          var n = e[4];
          if ("throw" === n.type) {
            var o = n.arg;
            m(e);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (r, e, n) {
      return this.delegate = {
        i: x(r),
        r: e,
        n: n
      }, "next" === this.method && (this.arg = t), f;
    }
  }, r;
}

/**
 * 判断字符串与正则表达式是否匹配
 * @param regexp
 */
function detect(regexp) {
  return function (str) {
    var _window;
    return regexp.test(str != null ? str : (_window = window) == null || (_window = _window.navigator) == null ? void 0 : _window.userAgent);
  };
}
/**
 * 判断是否是Native环境下
 */
var isNative = /*#__PURE__*/detect(/tmri/i);
var isAndroid = /*#__PURE__*/detect(/android/i);
var isHarmony = /*#__PURE__*/detect(/harmony/i);
function isIOS(str) {
  return detect(/iphone|ipod/i)(str) || isIPad(str);
}
function isIPad(str) {
  return detect(/iPad/i)(str) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

/* eslint-disable @typescript-eslint/consistent-type-assertions */
var JsonRPC = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function JsonRPC() {
    this.version = '2.0';
    this.callbacks = {};
    this.funcNames = {};
    this.queue = [];
    // TODO: 方法列表
    this.methods = {};
  }
  var _proto = JsonRPC.prototype;
  _proto.addMethod = function addMethod(key, value) {
    if (typeof key === 'string') {
      this.methods[key] = value;
    }
    if (Object.prototype.toString.call(key) === '[object Object]') {
      for (var k in key) {
        var propName = k;
        var item = key[k];
        if (this.methods[propName]) return;
        this.methods[propName] = item;
      }
    }
    return this;
  }
  // TODO: 移除方法
  ;
  _proto.removeMethod = function removeMethod(key) {
    this.methods[key] = null;
    return this;
  }
  // TODO: 清空方法列表
  ;
  _proto.clearMethod = function clearMethod() {
    this.methods = {};
  }
  /**
   * bridge初始化是需要时间的, 在bridge对象创建之前, 先放到缓存队列里
   * @param message
   */;
  _proto.send = function send(message) {
    if (typeof message !== 'string') {
      message = JSON.stringify(message);
    }
    this.queue.push(message);
  };
  _proto.notify = function notify(method, params) {
    var message = JSON.stringify({
      jsonrpc: this.version,
      method: method,
      params: params
    });
    this.send(message);
  };
  _proto.request = function request(method, params) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      // 如果非是Native环境, 直接返回 undefined
      if (!isNative) {
        return resolve(undefined);
      }
      var id = generateUUID();
      var startTime = Date.now();
      var callback = function callback(err, result) {
        // rpc 结束
        options == null || options.endProcess == null || options.endProcess(method, id, Date.now() - startTime, err);
        err ? reject(err) : resolve(result);
      };
      _this.callbacks[id] = callback;
      _this.funcNames[id] = method;
      var message = JSON.stringify({
        id: id,
        jsonrpc: _this.version,
        method: method,
        jsApiToken: options.jsApiToken,
        params: params,
        timestamp: startTime
      });
      // 发起rpc调用
      options == null || options.startProcess == null || options.startProcess(method, id);
      _this.send(message);
    });
  };
  _proto.error = function error(_ref) {
    var id = _ref.id,
      code = _ref.code,
      message = _ref.message,
      data = _ref.data;
    if (!id) {
      var err = new Error(message);
      err.code = code;
      err.data = data;
      throw err;
    }
    var _message = JSON.stringify({
      id: id,
      error: {
        code: code,
        message: message,
        data: data
      }
    });
    this.send(_message);
  }
  /**
   * onMessage
   * 处理两件事情，一个是H5调用Native的回调信息
   * 另一件事情，处理Native触发的监听函数
   * @param rawData
   */;
  _proto.onMessage = function onMessage(rawData) {
    var _this2 = this;
    var callbacks = this.callbacks,
      methods = this.methods,
      funcNames = this.funcNames;
    var message;
    try {
      message = JSON.parse(rawData);
    } catch (ex) {
      this.error({
        code: -32700,
        message: 'Parse error'
      });
    }
    var callback = callbacks[message.id];
    /**
     * 对于普通rpc, bridge.callHandler('onMessage', message)
     *    message = {id, method: 'localStorage.getItem', params:{key: "token"} }
     * 订阅 bridge.registerHandler('onMessage', (message: string) => {})
     *    native-IOS 接收 message = {id, method: 'localStorage.getItem', result: 'token值'}
     *    native-安卓 接收 message =  {id, method: 'localStorage.getItem', result: {token: "token值"}}
     */
    if ('result' in message || 'error' in message) {
      if (!message.id) {
        var msg = {
          message: "Internal error(\u65E0\u6CD5\u5904\u7406\u7684\u6570\u636E\u56DE\u8C03): " + rawData,
          code: -32603
        };
        this.error(msg);
      }
      if (!callback) {
        var _msg = {
          message: "Internal error(\u672A\u627E\u5230\u56DE\u8C03\u51FD\u6570): " + rawData,
          code: -32603
        };
        this.error(_msg);
        return;
      }
      if (message.error) {
        if (typeof message.error === 'object') {
          message.error._funName = this.funcNames[message.id] || '';
        }
        callback(message.error);
      } else {
        callback(null, message.result);
        // if (options.debug) {
        //   console.log("message.result 类型", typeof message.result);
        // }
      }
      callback = null;
      delete callbacks[message.id];
      delete funcNames[message.id];
      return;
    }
    /**
     * 对于消息订阅rpc, 会携带 {id, method: 'message.subscribe', params: { endpoint: 'app.resume'} }
     * native触发事件时, 会修改method为 'message.dispatch',
     *    携带内容为 {id, method: 'message.dispatch', params: { endpoint:'app.resume', message: '内容'} }
     */
    if ('method' in message) {
      var method = methods[message.method];
      if (!method) {
        this.error({
          id: message.id,
          message: 'Method not found',
          code: -32601
        });
        return;
      }
      Promise.resolve(method(message.params)).then(function (result) {
        if (result === void 0) {
          result = null;
        }
        if (message.id) {
          _this2.send(JSON.stringify({
            id: message.id,
            result: result
          }));
        }
      })["catch"](function (ex) {
        _this2.error({
          id: message.id,
          message: ex.message,
          code: ex.code,
          data: ex.data
        });
        throw ex;
      });
      return;
    }
    throw new Error('unknown message: ' + rawData);
  };
  return JsonRPC;
}();
var generateUUID = function generateUUID() {
  var d = new Date().getTime(); //Timestamp
  var d2 = performance && performance.now && performance.now() * 1000 || 0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};
var rpcInstance = /*#__PURE__*/new JsonRPC();

/**
 * 创建或更新存储对象中的某一项
 * @param key 键名
 * @param value 键值
 */
function setItem(key, value) {
  return rpcInstance.request('CLFJs.localStorage.setItem', {
    key: key,
    value: value
  });
}
/**
 * 从存储对象中获取某一项
 * @param key 键名
 */
function getItem(_x) {
  return _getItem.apply(this, arguments);
}
/**
 * 从存储对象中移除某一项
 *
 * @param key 键名
 */
function _getItem() {
  _getItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
    var result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return rpcInstance.request('CLFJs.localStorage.getItem', {
            key: key
          });
        case 2:
          result = _context.sent;
          if (!(typeof result === 'undefined')) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", null);
        case 5:
          if (!(result && typeof result === 'object')) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", result['valueString']);
        case 7:
          return _context.abrupt("return", result);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getItem.apply(this, arguments);
}
function removeItem(key) {
  return rpcInstance.request('CLFJs.localStorage.removeItem', {
    key: key
  });
}
/**
 * 清空存储对象
 */
function clear() {
  return rpcInstance.request('CLFJs.localStorage.clear');
}

var localStorage = {
  __proto__: null,
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem,
  clear: clear
};

/* eslint-disable prefer-const */
// Events
// -----------------
// Thanks to:
//  - https://github.com/documentcloud/backbone/blob/master/backbone.js
//  - https://github.com/joyent/node/blob/master/lib/events.js
// Regular expression used to split event strings
// A module that can be mixed in to *any object* in order to provide it
// with custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = new Events();
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//
var eventSplitter = /\s+/;
var Events = /*#__PURE__*/function () {
  function Events() {}
  var _proto = Events.prototype;
  _proto.on = function on(events, callback, context) {
    if (!callback) return this;
    var cache = this.__events || (this.__events = {});
    var _events = events.split(eventSplitter);
    var event = _events.shift();
    while (event) {
      var list = cache[event] || (cache[event] = []);
      list.push(callback, context);
      event = _events.shift();
    }
    return this;
  };
  _proto.off = function off(events, callback, context) {
    var cache = this.__events;
    if (!cache) return this;
    if (!(events || callback || context)) {
      this.__events = null;
      return this;
    }
    var _events = events ? events.split(eventSplitter) : Object.keys(cache);
    var event = _events.shift();
    while (event) {
      var list = cache[event];
      var next = function next() {
        return event = _events.shift();
      };
      if (!list) {
        next();
        continue;
      }
      if (!(callback || context)) {
        cache[event] = null;
        next();
        continue;
      }
      for (var i = list.length - 2; i >= 0; i -= 2) {
        if (!(callback && list[i] !== callback || context && list[i + 1] !== context)) {
          list.splice(i, 2);
        }
      }
      next();
    }
    return this;
  };
  _proto.trigger = function trigger(events) {
    var cache = this.__events;
    if (!cache) {
      return this;
    }
    var _events = events.split(eventSplitter);
    var returned = true;
    var rest = [];
    for (var i = 0, len = arguments.length <= 1 ? 0 : arguments.length - 1; i < len; i++) {
      rest[i] = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
    }
    var event = _events.shift();
    while (event) {
      var all = cache.all;
      var list = cache[event];
      if (all) {
        all = all.slice();
      }
      if (list) {
        list = list.slice();
      }
      if (event !== 'all') {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        returned = triggerEvents(list, rest, this) && returned;
      }
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      returned = triggerEvents(all, [event].concat(rest), this) && returned;
      event = _events.shift();
    }
    return returned;
  };
  return Events;
}();
function triggerEvents(list, args, context) {
  var pass = true;
  if (list) {
    var i = 0,
      l = list.length,
      a1 = args[0],
      a2 = args[1],
      a3 = args[2];
    // call is faster than apply, optimize less than 3 argu
    // http://blog.csdn.net/zhengyinhui100/article/details/7837127
    switch (args.length) {
      case 0:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context) !== false && pass;
        }
        break;
      case 1:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
        }
        break;
      case 2:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
        }
        break;
      case 3:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
        }
        break;
      default:
        for (; i < l; i += 2) {
          pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
        }
        break;
    }
  }
  // trigger will return false if one of the callbacks return false
  return pass;
}
var eventsInstance = /*#__PURE__*/new Events();

var MessageListener = {};
/**
 * 消息订阅
 *
 * @param endpoint 端点
 * @param callback 回调
 * @param context 上下文
 */
function on(_x, _x2, _x3) {
  return _on.apply(this, arguments);
}
/**
 * 消息退订
 *
 * @param endpoint 端点
 * @param callback 回调
 * @param context 上下文
 */
function _on() {
  _on = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(endpoint, callback, context) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (MessageListener[endpoint]) {
            _context.next = 8;
            break;
          }
          MessageListener[endpoint] = 0;
          eventsInstance.on(endpoint, callback, context);
          MessageListener[endpoint]++;
          _context.next = 6;
          return rpcInstance.request('message.subscribe', {
            endpoint: endpoint
          });
        case 6:
          _context.next = 10;
          break;
        case 8:
          eventsInstance.on(endpoint, callback, context);
          MessageListener[endpoint]++;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _on.apply(this, arguments);
}
function off(endpoint, callback, context) {
  if (!MessageListener[endpoint]) {
    MessageListener[endpoint] = 0;
  }
  MessageListener[endpoint]--;
  eventsInstance.off(endpoint, callback, context);
  if (MessageListener[endpoint] <= 0) {
    delete MessageListener[endpoint];
    rpcInstance.request('message.unsubscribe', {
      endpoint: endpoint
    });
  }
}
/**
 * 消息派发
 *
 * @param options 选项
 */
function dispatch(options) {
  return rpcInstance.request('message.dispatch', options);
}
/**
 * 消息广播
 *
 * @param options 选项
 */
function broadcast(options) {
  return rpcInstance.request('message.notification', options);
}
var message = {
  on: on,
  off: off,
  dispatch: dispatch,
  broadcast: broadcast
};

var NATIVE_SCHEMA = "carlifeapp";
var NATIVE_DOMAIN = 'carlife.com';
var NATIVE_BASE_URL = NATIVE_SCHEMA + "://" + NATIVE_DOMAIN;
/**
 * 跳转到 指定的原生页面, 并携带参数
 * 保留当前页面，跳转App内某页面，可以返回当前h5页面
 * 应该场景： 打开认证页面
 * @param to 原生页面 和 参数
 * @returns 无返回值
 */
function navigationTo(to) {
  if (isIOS() || isIPad()) {
    var path = NATIVE_BASE_URL + "?action=" + to.nativePage + "&params=" + to.params;
    return rpcInstance.request('CLFJs.page.navigationTo', {
      path: path
    });
  } else {
    var _path = NATIVE_BASE_URL + "?action=" + to.nativePage + "&params=" + to.params;
    return rpcInstance.request('CLFJs.page.navigationTo', {
      path: _path
    });
  }
}
/**
 * 跳转到 指定的原生页面, 并携带参数
 * 关闭当前页面，跳转App内某页面，不可以返回当前h5页面
 * 应该场景： 打开原生 首页 home,办理 progress,服务 service,我的 userprofile
 * @param to 原生页面 和 参数
 * @returns 无返回值
 */
function redirectTo(to) {
  if (isIOS() || isIPad()) {
    var path = NATIVE_BASE_URL + "?action=" + to.nativePage + "&params=" + to.params;
    return rpcInstance.request('CLFJs.page.redirectTo', {
      path: path
    });
  } else {
    var _path2 = NATIVE_BASE_URL + "?action=" + to.nativePage + "&params=" + to.params;
    return rpcInstance.request('CLFJs.page.redirectTo', {
      path: _path2
    });
  }
}
/**
 * 导航返回
 * 关闭h5容器，返回上一页
 * @returns 无返回值
 */
function navigationBack() {
  if (isIOS() || isIPad()) {
    return rpcInstance.request('CLFJs.page.navigationBack', {});
  } else {
    return rpcInstance.request('CLFJs.page.navigationBack', {});
  }
}
/**
 * 打开小程序并跳转到某一路径
 * @param params 小程序相关参数
 */
function openMiniApp(params) {
  var url = NATIVE_BASE_URL + "?action=webView&popToRoot=" + (params.popToRoot || '') + "&brandCode=" + (params.brandCode || '') + "&webType=" + params.webType + "&jsApiToken=" + (params.jsApiToken || '') + "&sceneType=" + (params.sceneType || '') + "&url=" + params.path;
  console.log(121, url);
  return rpcInstance.request('CLFJs.page.openScheme', {
    url: url
  });
}
/**
 * 打开csh并跳转到某一路径
 * @param params 小程序相关参数
 */
function openCSHApp(params) {
  var url = NATIVE_BASE_URL + "?action=webView&popToRoot=" + (params.popToRoot || '') + "&webType=2&url=" + params.path;
  return rpcInstance.request('CLFJs.page.openScheme', {
    url: url
  });
}
/**
 * Push View 参数
 *
 * @public
 */
// export interface NavigatorPushViewParams {
//   /**
//    * 标题
//    */
//   title: string;
//
//   /**
//    * 显示标题
//    */
//   isShowTitle: boolean;
//
//   /**
//    * URL
//    */
//   url: string;
//
//   /**
//    * 是否隐藏状态栏 (Android 独有)
//    */
//   isHideStatusBar?: boolean;
// }
/**
 * 打开H5
 *
 */
function openWebView(params) {
  return rpcInstance.request('CLFJs.page.openWebView', params);
}
/**
 * 跳转后端地址
 *
 */
function openScheme(params) {
  return rpcInstance.request('CLFJs.page.openScheme', params);
}
/**
 * 跳转到TabBar页面，并关闭其他所有非TabBar页面，路径需要是TabBar中的页面路径（或subPath, 仅支持history跳转时）
 */
function Switch(params) {
  return rpcInstance.request('CLFJs.tabBar.switch', params);
}

var pageRoute = {
  __proto__: null,
  navigationTo: navigationTo,
  redirectTo: redirectTo,
  navigationBack: navigationBack,
  openMiniApp: openMiniApp,
  openCSHApp: openCSHApp,
  openWebView: openWebView,
  openScheme: openScheme,
  Switch: Switch
};

// import { isNative, isAndroid } from '../tools';
/**
 * H5获取token
 *
 * @returns { token: '' }
 */
function getUserToken() {
  return rpcInstance.request('CLFJs.appInfo.getUserToken');
}
/**
 * H5获取用户信息
 *
 * @returns {  yhbh: '' } // 用户编号(用户id)
 */
function getUserInfo() {
  return rpcInstance.request('CLFJs.appInfo.getUserInfo');
}
/**
 * H5获取用户定位
 *
 * @returns locationParams
 */
function getLocation() {
  return rpcInstance.request('CLFJs.appInfo.getLocation');
}
/**
 * 获取App基础信息
 *
 * @returns appInfo
 */
function getAppInfo() {
  return rpcInstance.request('CLFJs.appInfo.getAppInfo');
}
/**
 * 是否支持某API
 *
 * @param url api地址
 * @returns isSupported
 */
function isSupported(url) {
  var params = {
    url: "CLFJs." + url
  };
  return rpcInstance.request('CLFJs.appInfo.isSupported', params);
}
/**
 * 登陆后状态同步
 *
 * @param account
 * @param password
 */
function userLogin(account, password) {
  return rpcInstance.request('CLFJs.appInfo.userLogin', {
    account: account,
    password: password
  });
}
/**
 * 退出登录
 */
function userLogout() {
  return rpcInstance.request('CLFJs.appInfo.userLogout');
}
// 横竖屏切换 1竖屏 3横屏
function screenChange(params) {
  return rpcInstance.request('CLFJs.appInfo.screenChange', params);
}
// 刷新办理页未读消息数
function reloadMessage(params) {
  return rpcInstance.request('CLFJs.appInfo.reloadMessage', params);
}
// 刷新办理页车辆列表
function reloadHandleVehicles(params) {
  return rpcInstance.request('CLFJs.appInfo.reloadHandleVehicles', params);
}
// 刷新
function reload() {
  return rpcInstance.request('CLFJs.appInfo.reload');
}
function getProjectDomain(params) {
  return rpcInstance.request('CLFJs.appInfo.getProjectDomain', params);
}
// 获取状态栏高度和屏幕高度
function getStatusBarHeight(params) {
  return rpcInstance.request('CLFJs.appInfo.getStatusBarHeight', params);
}
// 获取当前环境
// * @param params - 无
// * @returns {"env":'1'}  '1'表示测试环境，'2'表示生产环境 , {"logSwitch":1},将int转为二进制 , carlifeSwitch: 1 是正常进入页面， 0 是进入系统维护页面。
function getAppEnv() {
  return rpcInstance.request('CLFJs.appInfo.getAppEnv');
}

var appInfo = {
  __proto__: null,
  getUserToken: getUserToken,
  getUserInfo: getUserInfo,
  getLocation: getLocation,
  getAppInfo: getAppInfo,
  isSupported: isSupported,
  userLogin: userLogin,
  userLogout: userLogout,
  screenChange: screenChange,
  reloadMessage: reloadMessage,
  reloadHandleVehicles: reloadHandleVehicles,
  reload: reload,
  getProjectDomain: getProjectDomain,
  getStatusBarHeight: getStatusBarHeight,
  getAppEnv: getAppEnv
};

/**
 * H5拨打电话
 */
function makeACall(params) {
  return rpcInstance.request('CLFJs.appOperate.makeACall', params);
}
/**
 * 拍照
 *
 * @param params - 参数
 * @returns URL
 */
function takePhoto(params) {
  return rpcInstance.request('CLFJs.appOperate.takePhoto', _extends({
    acceptEncoding: 'path'
  }, params || {}));
}
/**
 * 唤起选择文件
 *
 * @param params - 参数
 */
function chooseFile(params) {
  return rpcInstance.request('CLFJs.appOperate.chooseFile', _extends({
    maxCount: 1,
    mediaType: 'image',
    acceptEncoding: 'path'
  }, params || {}));
}
function toMap(params) {
  return rpcInstance.request('CLFJs.appOperate.toMap', params);
}
// 获取APP缓存大小
function getCacheSize() {
  return rpcInstance.request('CLFJs.appOperate.getCacheSize');
}
// 清空APP缓存
function clearCache() {
  return rpcInstance.request('CLFJs.appOperate.clearCache');
}
// 打开三方App
function openApp(params) {
  return rpcInstance.request('CLFJs.appOperate.openApp', params);
}
/**
 * 设置车架号，返回accessId
 * @param params - { cjh: 'xxx' }
 * @returns { accessId: 'xxx' }
 * */
function setCjh(params) {
  return rpcInstance.request('CLFJs.appOperate.setCjh', params);
}
// 申请相机权限
/**
 * 申请相机权限
 *
 * @param params - 无
 * @returns { code: 1 } 1 有相机权限 0 没有相机权限
 */
function applyCameraPermission() {
  return rpcInstance.request('CLFJs.appOperate.applyCameraPermission');
}
function setNativeBackDisableState(params) {
  return rpcInstance.request('CLFJs.appOperate.setNativeBackDisableState', params);
}
/**
 * H5页面内部超时退出
 *
 * @param params - 无
 * @returns { code: 0 }
 */
function tokenExpired() {
  return rpcInstance.request('CLFJs.appOperate.tokenExpired');
}
function setStatusBarMode(params) {
  if (!isAndroid() && !isHarmony()) {
    throw new Error('该方法仅支持安卓平台和鸿蒙平台');
  }
  return rpcInstance.request('CLFJs.appOperate.setStatusBarMode', params);
}
var openPage = function openPage(params) {
  return rpcInstance.request('CLFJs.appOperate.openPage', params);
};

var appOperate = {
  __proto__: null,
  makeACall: makeACall,
  takePhoto: takePhoto,
  chooseFile: chooseFile,
  toMap: toMap,
  getCacheSize: getCacheSize,
  clearCache: clearCache,
  openApp: openApp,
  setCjh: setCjh,
  applyCameraPermission: applyCameraPermission,
  setNativeBackDisableState: setNativeBackDisableState,
  tokenExpired: tokenExpired,
  setStatusBarMode: setStatusBarMode,
  openPage: openPage
};

/**
 * 将指定车型加入车型对比
 *
 * @param carNo 车型编号
 */
function addComparison(carNo) {
  return rpcInstance.request('CLFJs.service.addComparison', {
    carNo: carNo
  });
}
// 刷新办理页未读消息数
function reloadMessage$1(params) {
  return rpcInstance.request('CLFJs.serve.reloadMessage', params);
}
// 刷新办理页车辆列表
function reloadHandleVehicles$1(params) {
  return rpcInstance.request('CLFJs.serve.reloadHandleVehicles', params);
}
// 新增心愿单
function addWishlist(params) {
  return rpcInstance.request('CLFJs.serve.addWishlist', params);
}
// 删除心愿单
function delWishlist(params) {
  return rpcInstance.request('CLFJs.serve.delWishlist', params);
}

var service = {
  __proto__: null,
  addComparison: addComparison,
  reloadMessage: reloadMessage$1,
  reloadHandleVehicles: reloadHandleVehicles$1,
  addWishlist: addWishlist,
  delWishlist: delWishlist
};

/**
 * H5获取用户简单授权
 *
 * @returns
 */
function getUserAuthNormally() {
  return rpcInstance.request('CLFJs.authorization.getUserAuthNormally');
}
/**
 * h5侧需要获取用户详细信息授权
 *
 * @returns
 */
function getUserAuthDeeply(params) {
  return rpcInstance.request('CLFJs.authorization.getUserAuthDeeply', params);
}
/**
 * 下订时的前置校验(三要素验证)
 *
 * @returns
 *  80000 用户同意授权，且成功返回授权码
 *  80001 用户拒绝授权
 *  80002 公告参数校验失败
 *  80020 未知错误（用户同意授权，但未成功返回授权码）
 */
function preValidate(params) {
  params.authType = '1';
  return rpcInstance.request('CLFJs.authorization.preValidate', params).then(function (res) {
    // 通过类型断言告诉 TypeScript res 是一个具体的对象
    var result = res;
    if (result.code === 80000) {
      return Promise.resolve(result); // 返回整个对象
    }
    return Promise.reject(result);
  });
}
/*
  80000 用户同意授权，且成功返回授权码
  80001 用户拒绝授权
  80003 无法匹配车架号
  80020 未知错误（用户同意授权，但未成功返回授权码）
  * */
function getUserInfoAndCarInfo(params) {
  return rpcInstance.request('CLFJs.authorization.getUserInfoAndCarInfo', params);
}
// 实名认证
function realNameAuth(params) {
  return rpcInstance.request('CLFJs.authorization.realNameAuth', params);
}
// 生成三方token
function getAuthToken(params) {
  return rpcInstance.request('CLFJs.authorization.generateSession', params);
}
// 保险授权
function getInsuranceAuth(params) {
  var data = {
    accessId: params.accessId,
    type: 'A02',
    authType: '1,2,3,4' // 1.用户信息，包括姓名、身份证号、手机号 2.合格证信息 3.发票信息 4.电子驾驶证信息
  };
  return rpcInstance.request('CLFJs.authorization.getUserInfoAndCarInfo', data);
}

var auth = {
  __proto__: null,
  getUserAuthNormally: getUserAuthNormally,
  getUserAuthDeeply: getUserAuthDeeply,
  preValidate: preValidate,
  getUserInfoAndCarInfo: getUserInfoAndCarInfo,
  realNameAuth: realNameAuth,
  getAuthToken: getAuthToken,
  getInsuranceAuth: getInsuranceAuth
};

var NativeAPI = {
  config: config,
  localStorage: localStorage,
  message: message,
  pageRoute: pageRoute,
  appInfo: appInfo,
  appOperate: appOperate,
  service: service,
  auth: auth
};

/**
 * 给rcp对象 添加 `message.dispatch` 方法
 */
rpcInstance.addMethod({
  'message.dispatch': function messageDispatch(_ref) {
    var endpoint = _ref.endpoint,
      message = _ref.message;
    eventsInstance.trigger(endpoint, message);
  }
});
/**
 * 超时计算队列, 用于在bridge初始化完成之后 才开始计算超时时间
 */
var waitingQueue = [];
function setupWebViewJavascriptBridge() {
  return new Promise(function (resolve, reject) {
    if (options.debug) {
      console.warn('native rpc initialed');
    }
    if (isNative() && (isIOS() || isHarmony())) {
      if (window.WebViewJavascriptBridge) return resolve(window.WebViewJavascriptBridge);
      if (window.WVJBCallbacks) return window.WVJBCallbacks.push(resolve);
      window.WVJBCallbacks = [resolve];
      var WVJBIframe = document.createElement('iframe');
      WVJBIframe.style.display = 'none';
      WVJBIframe.src = 'https://__bridge_loaded__';
      document.documentElement.appendChild(WVJBIframe);
      window.setTimeout(function () {
        return document.documentElement.removeChild(WVJBIframe);
      }, 0);
      return;
    }
    if (isNative() && isAndroid() || isNative() && isHarmony()) {
      if (window.WebViewJavascriptBridge) {
        return resolve(window.WebViewJavascriptBridge);
      }
      var listener = function listener() {
        if (window.WebViewJavascriptBridge) {
          resolve(window.WebViewJavascriptBridge);
        }
        document.removeEventListener('WebViewJavascriptBridgeReady', resolve);
      };
      document.addEventListener('WebViewJavascriptBridgeReady', listener, false);
      return;
    }
    reject(new Error('Unsupported platform'));
  });
}
function initJSBridge() {
  return _initJSBridge.apply(this, arguments);
}
function _initJSBridge() {
  _initJSBridge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var startTime, bridge, timeId, message, msgBody, diff;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 初始化jsBridge的开始时间
          startTime = Date.now();
          _context.prev = 1;
          options == null || options.startProcess == null || options.startProcess('jsBridge初始化', 'jsBridgeInit');
          _context.next = 5;
          return setupWebViewJavascriptBridge();
        case 5:
          bridge = _context.sent;
          // handle error
          try {
            if (isNative() && isAndroid() || isNative() && isHarmony()) {
              // define a default handler use init method, so that Java can send message to js without assigned handlerName
              bridge.init(function (_message, callback) {
                if (callback) callback('pong');
              });
            }
          } catch (error) {}
          options == null || options.endProcess == null || options.endProcess('jsBridge初始化', 'jsBridgeInit', Date.now() - startTime);
          timeId = setTimeout(function () {
            waitingQueue.forEach(function (fn) {
              return fn();
            });
            waitingQueue = [];
            clearTimeout(timeId);
          }, options.timeout);
          /**
           * 注册jsbridge监听
           * native send the message to js with an assigned handler named 'onMessage'
           */
          bridge.registerHandler('onMessage', function (message) {
            if (options.debug) {
              console.log('RPC.onMessage Native >>> JS', message);
            }
            rpcInstance.onMessage(message);
          });
          /**
           * 发送消息给native
           * bridge对象创建完成之后, 替换为调用bridge发送数据
           * js send message to native with an assigned handler named 'onMessage' by bridge.callhandler
           */
          rpcInstance.send = function (message) {
            if (options.debug) {
              console.log('RPC.send JS >>> Native', message);
            }
            return bridge.callHandler('onMessage', message);
          };
          /**
           * 队列缓存
           */
          if (!(rpcInstance.queue && rpcInstance.queue.length)) {
            _context.next = 29;
            break;
          }
          message = rpcInstance.queue.shift();
        case 14:
          if (!message) {
            _context.next = 29;
            break;
          }
          rpcInstance.send(message);
          message = rpcInstance.queue.shift();
          // 触发移除队列的事件
          _context.prev = 17;
          if (message) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("continue", 14);
        case 20:
          msgBody = JSON.parse(message);
          if (msgBody != null && msgBody.method && msgBody != null && msgBody.id && msgBody != null && msgBody.timestamp) {
            diff = Date.now() - msgBody.timestamp;
            options == null || options.onQueueShift == null || options.onQueueShift(msgBody.method, msgBody.id, diff);
          }
          _context.next = 27;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](17);
          // 吃掉错误
          console.error(_context.t0);
        case 27:
          _context.next = 14;
          break;
        case 29:
          _context.next = 39;
          break;
        case 31:
          _context.prev = 31;
          _context.t1 = _context["catch"](1);
          if (!(_context.t1.message === "Unsupported platform")) {
            _context.next = 36;
            break;
          }
          console.error("当前平台不支持jsBridge");
          return _context.abrupt("return");
        case 36:
          rpcInstance.send = function () {
            throw new Error("jsBridge's initialization failed");
          };
          options.endProcess == null || options.endProcess('jsBridge初始化', 'jsBridgeInit', Date.now() - startTime, _context.t1);
          throw _context.t1;
        case 39:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 31], [17, 24]]);
  }));
  return _initJSBridge.apply(this, arguments);
}

// 初始化jsBridge
initJSBridge();

export default NativeAPI;
//# sourceMappingURL=native-api.esm.js.map



// WEBPACK FOOTER //
// ./src/nativeApi/native-api.esm.js